import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { MyCalendarMobilePage } from '@/pages/my-calendar/my-calendar-mobile-page';
import { MyCalendarPage } from '@/pages/my-calendar/my-calendar-page';
import { useMobile } from '@/shared/lib/use-mobile';

/**
 * `/my/calendar?mode=month|week&month=YYYY-MM&weekOf=YYYY-MM-DD&day=YYYY-MM-DD&task=KEY`
 * — Calendar layers My plan · Deadlines · Waiting & shared · Milestones ·
 * Timesheet (§5 W4-B). Desktop: Month (default) or Week grid. Phone: Month
 * (a compact grid + the tapped `day`'s list, the restored 68f6cbe phone
 * calendar) or the Week agenda (`weekOf`); an old `?month=` link lands on
 * Month. Bad values are dropped, not errors.
 */
const myCalendarSearch = z.object({
  mode: z.enum(['month', 'week']).optional().catch(undefined),
  month: z
    .string()
    .regex(/^\d{4}-\d{2}$/)
    .optional()
    .catch(undefined),
  weekOf: z
    .string()
    .regex(/^\d{4}-\d{2}-\d{2}$/)
    .optional()
    .catch(undefined),
  /** Phone Month: the selected day (its list shows under the grid). */
  day: z
    .string()
    .regex(/^\d{4}-\d{2}-\d{2}$/)
    .optional()
    .catch(undefined),
  /** The open task (`useTaskUrl`, `?task=KEY`) — kept so Back closes it. */
  task: z.string().optional().catch(undefined),
});

export type MyCalendarSearch = z.infer<typeof myCalendarSearch>;

function MyCalendarRoute() {
  const isMobile = useMobile();
  return isMobile ? <MyCalendarMobilePage /> : <MyCalendarPage />;
}

export const Route = createFileRoute('/my/calendar')({
  validateSearch: myCalendarSearch,
  component: MyCalendarRoute,
});
